export const useBlogActions = (
  state: any, 
  setState: any, 
  queries: any, 
  setNotification: any
) => {
  const form = state.form;
  const currentNote = state.currentNote;
  const selectedNotes = state.selectedNotes;
  const isAuthenticated = queries.isAuthenticated;
  const meData = queries.meData;

  const handleCreate = async () => {
    if (!form.title || !form.content) {
      return setNotification({ type: 'error', message: 'Заполните обязательные поля' });
    }
    try {
      await queries.createNote({
        variables: {
          title: form.title, 
          content: form.content, 
          image: form.image, 
          previewImage: form.previewImage,
          tags: form.tags.split(',').map((t: string) => t.trim()).filter(Boolean),
          attachments: form.attachments.map((a: any) => ({ 
            filename: a.filename, 
            contentType: a.contentType, 
            data: a.data 
          })),
        }
      });
      setNotification({ type: 'success', message: 'Статья создана' });
      setState.setForm({ title: '', content: '', image: '', previewImage: '', tags: '', attachments: [] });
      setState.setMode('list');
      
      // ✅ МГНОВЕННОЕ ОБНОВЛЕНИЕ СПИСКА
      await queries.refetch();
    } catch (err: any) {
      setNotification({ type: 'error', message: `Ошибка: ${err.message}` });
    }
  };

  const handleEdit = async () => {
    if (!currentNote) return;
    
    const formAttachmentIds = new Set(
      form.attachments.filter((a: any) => a.id).map((a: any) => a.id)
    );
    const newAttachments = form.attachments
      .filter((a: any) => !a.id)
      .map((a: any) => ({ filename: a.filename, contentType: a.contentType, data: a.data }));
    const attachmentIdsToDelete = currentNote.attachments
      .filter((a: any) => !formAttachmentIds.has(a.id))
      .map((a: any) => a.id);

    try {
      // Оптимистичное обновление UI
      const updatedNote = {
        ...currentNote, 
        title: form.title, 
        content: form.content, 
        image: form.image, 
        previewImage: form.previewImage,
        tags: form.tags.split(',').map((t: string) => t.trim()).filter(Boolean),
        attachments: [
          ...currentNote.attachments.filter((a: any) => formAttachmentIds.has(a.id)), 
          ...newAttachments.map((a: any, i: number) => ({ ...a, id: `temp-${i}` }))
        ],
      };
      
      setState.setCurrentNote(updatedNote);
      setState.setNotes((prev: any[]) => prev.map(n => n.id === currentNote.id ? updatedNote : n));

      await queries.updateNote({
        variables: { 
          id: currentNote.id, 
          title: form.title, 
          content: form.content, 
          image: form.image, 
          previewImage: form.previewImage,
          tags: updatedNote.tags, 
          attachments: newAttachments, 
          attachmentIdsToDelete 
        }
      });
      setNotification({ type: 'success', message: 'Заметка обновлена' });
      setState.setMode('view');
      
      // ✅ Синхронизируем с сервером на фоне
      await queries.refetch();
    } catch (err: any) {
      setNotification({ type: 'error', message: `Ошибка: ${err.message}` });
      await queries.refetch(); // Откат к актуальным данным при ошибке
    }
  };

  const handleDeleteNote = async (id: string) => {
    try {
      await queries.deleteNote({ variables: { id } });
      setNotification({ type: 'success', message: 'Заметка удалена' });
      if (state.currentNote?.id === id) setState.setMode('list');
      if (selectedNotes.has(id)) {
        const newSel = new Set(selectedNotes); 
        newSel.delete(id); 
        setState.setSelectedNotes(newSel);
      }
      // ✅ МГНОВЕННОЕ ОБНОВЛЕНИЕ СПИСКА
      await queries.refetch();
    } catch (err: any) {
      setNotification({ type: 'error', message: `Ошибка: ${err.message}` });
    }
  };

  const handleDeleteSelected = async () => {
    if (selectedNotes.size === 0) return;
    try {
      await Promise.all(Array.from(selectedNotes).map(id => queries.deleteNote({ variables: { id } })));
      setNotification({ type: 'success', message: 'Заметки удалены' });
      setState.setSelectedNotes(new Set());
      if (state.currentNote && selectedNotes.has(state.currentNote.id)) {
        setState.setMode('list');
      }
      // ✅ МГНОВЕННОЕ ОБНОВЛЕНИЕ СПИСКА
      await queries.refetch();
    } catch (err: any) {
      setNotification({ type: 'error', message: `Ошибка: ${err.message}` });
    }
  };

  const handleToggleFavorite = async (id: string) => {
    if (!isAuthenticated) return;
    
    const userId = meData?.me?.id;
    const username = meData?.me?.username;

    setState.setNotes((prev: any[]) => prev.map(note => {
      if (note.id === id) {
        const isFav = note.favoritedBy.some((u: any) => u.id === userId);
        return {
          ...note,
          favoritedBy: isFav 
            ? note.favoritedBy.filter((u: any) => u.id !== userId) 
            : [...note.favoritedBy, { id: userId, username }]
        };
      }
      return note;
    }));

    try {
      await queries.toggleFavorite({ variables: { id } });
      await queries.refetch();
      if (state.currentNote?.id === id) {
        const { data } = await queries.getNoteById({ variables: { id } });
        setState.setCurrentNote(data?.note || null);
      }
    } catch (err: any) {
      setNotification({ type: 'error', message: `Ошибка: ${err.message}` });
      await queries.refetch();
    }
  };

  return {
    handleCreate, 
    handleEdit, 
    handleDeleteNote, 
    handleDeleteSelected, 
    handleToggleFavorite,
    confirmAndDeleteNote: (id: string) => setState.setConfirmDeleteId(id),
    confirmAndDeleteSelected: () => setState.setConfirmDeleteMultiple(true),
  };
};